import EnrollmentDocumentsStage from "@/components/course-progress/stages/EnrollmentDocumentsStage";

export default function IdentityDocuments() {
  return <EnrollmentDocumentsStage mode="student" />;
}
